import fetch from "auth/FetchInterceptor";

export const EmployeeService = {};

EmployeeService.get = async ({
  page,
  pageSize,
  sort,
  searchText,
  role,
  state = null,
}) => {
  let apiUrl = "/v1/user?page=" + page + "&per_page=" + pageSize;
  if (sort === "ascend") apiUrl += "&order_by=%2Did";
  else if (sort === "descend") apiUrl += "&order_by=%2Bid";
  if (searchText) apiUrl += "&name=" + searchText;
  if (role) apiUrl += "&role=" + role;
  if (state) {
    apiUrl += "&state=" + state;
  }
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

EmployeeService.getById = async (id) => {
  const apiUrl = `/v1/user/${id}`;
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

EmployeeService.getAttendance = async ({ id, page, pageSize }) => {
  let apiUrl =
    "/v1/user/" + id + "/attendance?page=" + page + "&per_page=" + pageSize;
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

EmployeeService.createEmployee = async (data) => {
  const apiUrl = `/v1/user`;
  return fetch({
    url: apiUrl,
    method: "post",
    data: data,
  });
};

EmployeeService.updateEmployee = async (data) => {
  const apiUrl = `/v1/user/${data.id}`;
  return fetch({
    url: apiUrl,
    method: "put",
    data: data,
  });
};

EmployeeService.deleteEmployee = async (id) => {
  const apiUrl = `/v1/user/${id}`;
  return fetch({
    url: apiUrl,
    method: "delete",
  });
};

export default EmployeeService;
